"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.all = exports.hatchery = exports.hatcheryPerZone = undefined;

var _reselect = require("reselect");

var _zones = require("../zones");

var Zones = _interopRequireWildcard(_zones);

var _stats = require("./stats");

var UnitStats = _interopRequireWildcard(_stats);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Decimal = UnitStats.Decimal;
// Production multipliers.
var hatcheryPerZone = exports.hatcheryPerZone = function hatcheryPerZone(s, p) {
  return 1.4;
};
// expose all multipliers, or one at a time.
var hatchery = exports.hatchery = (0, _reselect.createSelector)(Zones.totalClears, hatcheryPerZone, function (clears, each) {
  return Decimal(each).pow(clears);
});

var all = exports.all = (0, _reselect.createStructuredSelector)({
  hatchery: hatchery
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdW5pdHMvcHJvZC1tdWx0aXMuanMiXSwibmFtZXMiOlsiWm9uZXMiLCJVbml0U3RhdHMiLCJEZWNpbWFsIiwiaGF0Y2hlcnlQZXJab25lIiwicyIsInAiLCJoYXRjaGVyeSIsInRvdGFsQ2xlYXJzIiwiY2xlYXJzIiwiZWFjaCIsInBvdyIsImFsbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVBOztBQUNBOztJQUFZQSxLOztBQUNaOztJQUFZQyxTOzs7O0FBQ1osSUFBTUMsVUFBVUQsVUFBVUMsT0FBMUI7QUFKQTtBQU1PLElBQU1DLDRDQUFrQixTQUFsQkEsZUFBa0IsQ0FBQ0MsQ0FBRCxFQUFTQyxDQUFUO0FBQUEsU0FBb0IsR0FBcEI7QUFBQSxDQUF4QjtBQUNQO0FBQ08sSUFBTUMsOEJBQVcsOEJBQ3RCTixNQUFNTyxXQURnQixFQUV0QkosZUFGc0IsRUFHdEIsVUFBQ0ssTUFBRCxFQUFTQyxJQUFUO0FBQUEsU0FBa0JQLFFBQVFPLElBQVIsRUFBY0MsR0FBZCxDQUFrQkYsTUFBbEIsQ0FBbEI7QUFBQSxDQUhzQixDQUFqQjs7QUFPQSxJQUFNRyxvQkFBWSx3Q0FBeUI7QUFDaERMO0FBRGdELENBQXpCLENBQWxCIiwiZmlsZSI6InByb2QtbXVsdGlzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8vIFByb2R1Y3Rpb24gbXVsdGlwbGllcnMuXG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yLCBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3J9IGZyb20gXCJyZXNlbGVjdFwiXG5pbXBvcnQgKiBhcyBab25lcyBmcm9tIFwiLi4vem9uZXNcIlxuaW1wb3J0ICogYXMgVW5pdFN0YXRzIGZyb20gXCIuL3N0YXRzXCJcbmNvbnN0IERlY2ltYWwgPSBVbml0U3RhdHMuRGVjaW1hbFxuXG5leHBvcnQgY29uc3QgaGF0Y2hlcnlQZXJab25lID0gKHM6IGFueSwgcDogYW55KSA9PiAxLjRcbi8vIGV4cG9zZSBhbGwgbXVsdGlwbGllcnMsIG9yIG9uZSBhdCBhIHRpbWUuXG5leHBvcnQgY29uc3QgaGF0Y2hlcnkgPSBjcmVhdGVTZWxlY3RvcihcbiAgWm9uZXMudG90YWxDbGVhcnMsXG4gIGhhdGNoZXJ5UGVyWm9uZSxcbiAgKGNsZWFycywgZWFjaCkgPT4gRGVjaW1hbChlYWNoKS5wb3coY2xlYXJzKSxcbilcblxudHlwZSBhbGxUID0gKCosICopID0+IHtbcGFyZW50OiBzdHJpbmddOiBEZWNpbWFsfVxuZXhwb3J0IGNvbnN0IGFsbDogYWxsVCA9IGNyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcih7XG4gIGhhdGNoZXJ5LFxufSlcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/units/prod-multis.js
// module id = 372
// module chunks = 0